import type { SessionView } from '@dashai/lib/chatStoreClient';
import type { ChatSession } from '@dashai/types/dashai';

// The name every chat list gives a chat without a title.
const UNTITLED_CHAT = 'New Chat';

// A stored session as the chat list shows it. The store no longer joins the
// first user message, so an untitled session reads 'New Chat'.
export function toChatSession(s: SessionView): ChatSession {
  return {
    chat_id: s.chat_id,
    title: s.title || UNTITLED_CHAT,
    country: s.country ?? undefined,
    filter_view_id: s.filter_view_id ?? null,
    is_starred: s.is_starred || false,
    share_token: s.share_token ?? undefined,
    created_at: s.created_at ?? undefined,
    last_message_at: s.updated_at ?? undefined,
  };
}

// A chat's title as the chat lists show it: prefixed with its market unless the
// title already starts with it.
export function chatDisplayTitle(session: ChatSession): string {
  const title = session.title || UNTITLED_CHAT;
  return session.country && !title.startsWith(`${session.country}:`) ? `${session.country}: ${title}` : title;
}

// A chat's title as rename edits it: the stored title without its market
// prefix, which is presentation.
export function editableChatTitle(session: ChatSession): string {
  const stored = session.title || '';
  return session.country && stored.startsWith(`${session.country}: `)
    ? stored.slice(session.country.length + 2)
    : stored;
}

const lastMessageTime = (session: ChatSession) => new Date(session.last_message_at).getTime();

// The given chats, most recently active first.
export const byLatestMessage = (a: ChatSession, b: ChatSession) => lastMessageTime(b) - lastMessageTime(a);
